import apis from '@/api/car'

const listConfig = [
    { title: '车牌号', key: 'carNo' },
    { title: '车型', key: 'carType' },
    { title: '挂车号', key: 'carGno' },
    { title: '轴数', key: 'axleNumName' },
    {
        title: '动力类型', key: 'powerType', showData: {
            "1": '汽油',
            "2": '柴油',
        }
    },
    {
        title: '厢型', key: 'boxType', showData: {
            "1": '厢车',
            "2": '高栏',
            "3": '平板',
            "4": '冷藏',
        }
    },
    {
        title: '状态', key: 'auditState', showData: {
            1: '已认证',
            2: '未认证',
            3: '认证中',
            4: '认证失败',
        }
    },
    { title: '备注', key: 'remark' }
]

const btnConfig = [
    { bg: '#19458C', title: '认 证', key: 'auditlist', role: 'SHRZ' },
    { bg: '#19458C', title: '新 建', key: 'add', role: 'ADD' },
    { bg: '#19458C', title: '编 辑', key: 'update', role: 'Edit' },
    { bg: '#C6C6C6', title: '删 除', key: 'delete', role: 'Del' },
    { bg: '#EA5B24', title: '加入黑名单', key: 'blacklist', role: 'JRHMD' },
]

const notRequired = true;
function fromConfig() {
    return [
        { title: '车牌号', value: '', key: 'carNo', type: 'input' },
        { title: '车型', value: '', key: 'carType', type: 'input' },
        { title: '挂车号', value: '', key: 'carGno', type: 'input', notRequired },
        { title: '备注', value: '', key: 'remark', type: 'input', notRequired }
    ]
}

function createBlack() {
    const blackConfirm = [
        { column: '加入黑名单' },
        { title: '拉黑原因', value: '', key: 'remark', type: 'textarea', span: 24 }
    ]
    return blackConfirm;
}

const disabled =  true;

function createAudit() {
    const blackConfirm = [
        { column: '审 核 信 息' },
        { title: '车牌号', value: '', key: 'carNo', type: 'input',span: 12, notRequired,disabled },
        {
            title: '动力类型', value: '', key: 'powerType',type: 'select',
            list: [
                {label: '汽油', value: '1'},
                {label: '柴油', value: '2'},
            ], span: 12,
            notRequired,disabled
        },
        {
            title: '厢型', value: '', key: 'boxType',type: 'select',
            list: [
                {label: '厢车', value: '1'},
                {label: '高栏', value: '2'},
                {label: '平板', value: '3'},
                {label: '冷藏', value: '4'},
            ], span: 12,
            notRequired,disabled
        },
        {title: '车型', value: '', key: 'carType', type: 'input',span: 12, notRequired,disabled },
        {title: '轴数', value: '', key: 'axleNumName', type: 'input',span: 12, notRequired,disabled },
        { column: '审 核 证 件' },
        {title: '双联照片', value: '', key: 'drivingPermitFull', type: 'upload', span: 12, notRequired,disabled},
        {title: '副页背面', value: '', key: 'drivingPermitBack', type: 'upload', span: 12, notRequired,disabled},
        {title: '人车合影', value: '', key: 'carFull', type: 'upload', span: 12, notRequired,disabled},
        {title: '道路运输证', value: '', key: 'permitFull', type: 'upload', span: 12, notRequired,disabled},
        {title: '车辆保险', value: '', key: 'carInsurancePhoto', type: 'upload', span: 12, notRequired,disabled},
        { column: '挂 车' },
        {title: '挂车号', value: '', key: 'carGno', type: 'input',span: 12, notRequired,disabled },
        {title: '挂车轴数', value: '', key: 'gAxleNumName', type: 'input',span: 12, notRequired,disabled },
        {title: '双联照片', value: '', key: 'trailerFull', type: 'upload', span: 12, notRequired,disabled},
        {title: '副页照片', value: '', key: 'trailerBack', type: 'upload', span: 12, notRequired,disabled},
        {
            title: '状态', value: '', key: 'auditState',type: 'select',
            list: [
                {label: '认证成功', value: 1},
                {label: '认证失败', value: 2},
            ],
            span: 12
        },
        { title: '备注', value: '', key: 'remark', type: 'textarea', span: 24,notRequired }
    ]
    return blackConfirm;
}

export default function config() {
    const searchConfig = [
        { title: '车牌号', value: '', key: 'carNo', type: 'input' }
    ]
    return {
        listConfig,
        btnConfig,
        searchConfig,
        fromConfig,
        createBlack,
        createAudit,
        apis
    }
}
